import { TklStat } from "../../model/domain/TklStat";
import { TklStatTO } from "../to/TklStatTO";

export const toDomain = (to: TklStatTO): TklStat =>
  ({...to} as TklStat);

export default {
  toDomain,
};